import React, { useEffect, useContext, useState, useCallback, useRef } from 'react'
import { FormContainer } from '../../uiwidgets/FormContainer';
import { FormField } from '../../uiwidgets/FormField';
import ProvinceSelect from 'uiwidgets/ProvinceSelect';
import PostalCode from 'uiwidgets/PostalCode';
import CountrySelect from 'uiwidgets/CountrySelect';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { CancelButton } from '../../uiwidgets/CancelButton';
import { Row, Col, Table, Image, Button } from 'react-bootstrap';
import { TenantContext } from '../../tenant/TenantContext';
import { SecurityContext } from 'security/SecurityContext';
import { evenRound } from '../../util/NumberUtils';
import useExternalScripts from 'util/useExternalScripts';
import { API } from 'api/API';
import {
    PROFILE_URL, BUSINESS_DONATION_CAUSES, ONECLICKPAYMENTS_URL,
    BUSINESS_DONATION_CAUSES_URL, PAYMENT_CARDS
} from 'config/config';
import { extractError } from 'api/ErrorUtil';
import { formatCurrency } from 'util/Currency';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    isEmailAddressValid, isPostalCodeValid,
    isPhoneValid, isNumeric, containsAlphabetsOnly,
    isValidUUID, containsAlphaNumAndSpaceOnly
} from "util/Validators";
import _ from "lodash";
import { validAddress } from 'util/Validators';
import { openLightbox } from 'util/ElavonLightBox';
import AppSpinner from 'uiwidgets/AppSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import StripeElements from 'util/StripeElements';

const OneClickPaymentPage = () => {
    const { businessConfig } = useContext(TenantContext);
    useExternalScripts(businessConfig.elavonLightboxUrl);
    const [formData, setFormData] = useState({
        country: "CA", state: "ON", donationLineItems: [], totalDonationAmount: null,
        currentDonationCause: "", currentDonationCauseValue: "0.00", oneClickPayment: null,
        editMode: false, receiptInCompanyName: false,
        paymentCards: [], paymentCardId: ""
    });
    const [formValidityData, setFormValidityData] = useState({});

    const [selectedCauseAttributes, setSelectedCauseAttributes] = useState([]);
    const [hasDescription, setHasDescription] = useState(false);
    const [mediaType, setMediaType] = useState("");
    const secCtx = useContext(SecurityContext);
    const navigate = useNavigate();
    const causeAmountFieldRef = useRef(null);
    const requestParams = useParams();
    const location = useLocation();
    const paymentGateway = businessConfig.paymentGateway;
    const saveCardFunction = useRef(null);

    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }
    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }


    const getPaymentCards = async () => {
        try {
            let paymentCards = await API.get(PAYMENT_CARDS);
            return paymentCards.data
        } catch (err) {
            let errors = extractError(err);
            if (errors.httpStatus !== 404) {
                setFormData({ ...formData, errors: errors });
                return;
            }
        };
    };

    const getDonationAccountId = () => {
        let donationAccountType = businessConfig.accountTypes.filter(accountType => accountType.accountType === 'DONATION')
        let donationAccount = secCtx.accounts.filter(account => account.accountTypeId === donationAccountType[0].id)
        return donationAccount[0];
    }
    const fetchProfileAndDonationCauses = useCallback(async () => {
        try {
            let oneClickPayment = {};
            let profile = {};
            let editMode = false;
            let savedDonationCause = "";
            let savedDonationCauseValue = 0.00;
            let savedTotalDonationAmount = 0.00;
            let paymentCards = await getPaymentCards();

            if (requestParams.oneclickpmtid) {
                editMode = true;
                //fetch recurring payment records
                oneClickPayment = location.state.oneClickPmtSpec;
                profile = oneClickPayment.payer;
            }

            let donationCauseResp = await API.get(BUSINESS_DONATION_CAUSES + '?nonSponsorshipOnly=true');
            let donationCauses = donationCauseResp.data;
            let lineItems = [];
            let valLineItems = [];
            for (let i = 0; i < donationCauses.length; i++) {
                let oneClickPaymentSpecDetailId = "";
                if (editMode) {
                    let oneClickPaymentSpecDetail = oneClickPayment.oneClickPaymentSpecDetail.filter(opsd => opsd.causeId === donationCauses[i].id);
                    if (oneClickPaymentSpecDetail && oneClickPaymentSpecDetail.length > 0) {
                        oneClickPaymentSpecDetailId = oneClickPaymentSpecDetail[0].oneClickPaymentSpecDetailId
                    }
                }
                lineItems[i] = {
                    causeId: donationCauses[i].id,
                    causeCode: donationCauses[i].donationCauseCode,
                    causeAmount: "0.00",
                    lineItemDescription: donationCauses[i].donationCauseDescription,
                    donationCauseAttributes: donationCauses[i].donationCauseAttributes,
                    mediaType: donationCauses[i].mediaType,
                    oneClickPaymentSpecDetailId: oneClickPaymentSpecDetailId
                };
                valLineItems[i] = {
                    donationLineItemError: false,
                    donationLineItemErrMsg: ""
                };
            }
            if (editMode) {
                if (oneClickPayment?.oneClickPaymentSpecDetail.length > 0) {
                    savedDonationCause = oneClickPayment.oneClickPaymentSpecDetail[0].causeId;
                    savedDonationCauseValue = evenRound(parseFloat(oneClickPayment.oneClickPaymentSpecDetail[0].causeAmount) / 100, 2);
                    savedTotalDonationAmount = evenRound(parseFloat(oneClickPayment.paymentAmount) / 100, 2)
                    setFormData({
                        ...formData, donationCauses: donationCauses, donationLineItems: lineItems, ...profile,
                        totalDonationAmount: savedTotalDonationAmount,
                        paymentFreq: 'MONTHLY', editMode: editMode,
                        currentDonationCause: savedDonationCause, currentDonationCauseValue: savedDonationCauseValue,
                        description: oneClickPayment.description, oneClickPayment: oneClickPayment,
                        receiptInCompanyName: oneClickPayment.receiptInCompanyName,
                        paymentCards: paymentCards
                    });
                }
            } else {
                let profileResp = await API.get(PROFILE_URL);
                profile = profileResp.data;
                setFormData({
                    ...formData, donationCauses: donationCauses, donationLineItems: lineItems, ...profile, totalDonationAmount: null,
                    paymentFreq: 'MONTHLY', editMode: editMode,
                    paymentCards: paymentCards
                });
            }
            setFormValidityData({ donationLineItems: valLineItems });
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError
            });
        }
    });

    useEffect(() => {
        fetchProfileAndDonationCauses();
    }, []);

    const handleFormDataChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleCountryChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let defaultState = "ON";
        if (value === "US") {
            defaultState = "MI";
        }
        setFormData({
            ...formData,
            [name]: value,
            state: defaultState
        });
    }

    const selectDonationCause = (donationCauseId) => {
        for (let donationLineItem of formData.donationLineItems) {
            if (donationLineItem.causeId === donationCauseId) {
                let hasDesc = donationLineItem.donationCauseAttributes && donationLineItem.donationCauseAttributes.filter(sa => !_.isEmpty(sa.description)).length > 0;
                setMediaType(donationLineItem.mediaType);
                setHasDescription(hasDesc);
                setSelectedCauseAttributes(donationLineItem.donationCauseAttributes);
            }
        }
    }

    const handleDonationCauseChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        selectDonationCause(value);
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleCancel = async (event) => {
        event.preventDefault();
        navigate(-1);
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "description":
                if (value.trim() === "") {
                    hasError = true
                    error = "Description cannot be empty"
                } else if (value.length > 32) {
                    hasError = true
                    error = "Invalid description. Description must be less than 32 characters";
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Description can have only alphanumeric characters";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "firstName":
                if (value.trim() === "") {
                    hasError = true
                    error = "First name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid First Name. Only alphbest are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "lastName":
                if (value.trim() === "") {
                    hasError = true
                    error = "Last name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Last Name. Only alphbest are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "address":
                if (value.trim() === "") {
                    hasError = true
                    error = "Address name cannot be empty"
                } else if (!validAddress(value)) {
                    hasError = true
                    error = "Invalid Address. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "city":
                if (value.trim() === "") {
                    hasError = true
                    error = "City name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid First Name. Only alphbest are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "state":
                if (value.trim() === "") {
                    hasError = true
                    error = "State name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid State. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "country":
                if (value.trim() === "") {
                    hasError = true
                    error = "Country name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Country. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "email":
                if (value.trim() === "") {
                    hasError = true
                    error = "Email cannot be empty"
                } else if (!isEmailAddressValid(value)) {
                    hasError = true
                    error = "Invalid Email"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "mobilePhoneNumber":
                if (value.trim() === "") {
                    hasError = true
                    error = "Mobile cannot be empty"
                } else if (!isPhoneValid(value)) {
                    hasError = true
                    error = "Invalid Mobile Number. Use 10 digits only"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "officePhoneNumber":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isPhoneValid(value)) {
                    hasError = true
                    error = "Invalid Office Number. Use 10 digits only"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "zip":
                if (value.trim() === "") {
                    hasError = true
                    error = "Postal Code cannot be empty"
                } else if (!isPostalCodeValid(value, formData.country)) {
                    hasError = true
                    error = "Invalid Postal Code"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "donationLineItems":
                if (!isNumeric(value)) {
                    hasError = true
                    error = "Payment Amount must be numeric"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "currentDonationCause":
                if (!value) {
                    hasError = true;
                    error = "Donation Cause is required. Please select one."
                } else if (!isValidUUID(value)) {
                    hasError = true;
                    error = "Donation cause is invalid."

                } else {
                    hasError = false
                    error = ""
                }
                break
            case "currentDonationCauseValue":
                if (!value) {
                    hasError = true;
                    error = "Donation Amount is required."
                } else if (!isNumeric(value) || parseFloat(value) <= 0.00) {
                    hasError = true;
                    error = "Donation Amount is invalid."

                } else {
                    hasError = false
                    error = ""
                }
                break
            default:
                break
        }
        return { hasError, error }
    }

    const handlePaymentResult = async ({ paymentStatus, errors, response, cardTokenId }) => {
        if (paymentStatus !== 'SUCCEEDED') {
            setFormData({
                ...formData,
                errors: errors,
                processing: false
            })
            return false;
        }
        let donationAccount = getDonationAccountId();
        let dliList = [];
        let totalDonationAmount = 0.00;
        for (let donationLineItem of formData.donationLineItems) {
            if (donationLineItem.causeId === formData.currentDonationCause) {
                let dliClone = _.cloneDeep(donationLineItem);
                dliClone.causeAmount = Math.trunc(evenRound(parseFloat(formData.currentDonationCauseValue) * 100));
                dliList.push(dliClone)
                totalDonationAmount = evenRound(totalDonationAmount + parseFloat(dliClone.causeAmount), 2);
            }
        }
        const oneClickPaymentSpec = {
            gwCardTokenResponse: response,
            oneClickPaymentSpecDetail: dliList,
            accountId: donationAccount.id,
            customerConsentsToPayPfFees: formData.customerConsentsToPayPfFees,
            paymentAmount: totalDonationAmount,
            description: formData.description,
            receiptInCompanyName: formData.receiptInCompanyName,
            paymentCardId: formData.paymentCardId,

            payer: {
                email: formData.email,
                firstName: formData.firstName,
                lastName: formData.lastName,
                address: formData.address,
                city: formData.city,
                state: formData.state,
                zip: formData.zip,
                country: formData.country,
                mobilePhoneNumber: formData.mobilePhoneNumber
            }
        }
        try {
            let oneClickResp = null;
            if (formData.editMode) {
                oneClickResp = await API.put(ONECLICKPAYMENTS_URL + "/" + formData.oneClickPayment.id, oneClickPaymentSpec);
            } else {
                oneClickResp = API.post(ONECLICKPAYMENTS_URL, oneClickPaymentSpec);
            }
            setFormData({
                ...formData,
                readOnly: true,
                processing: false,
                errors: {},
                infoMessage: 'OneClick Payment was added successfully. Click on the "Return to List Page".'
            });
        } catch (error) {
            let errors = extractError(error);
            setFormData({
                ...formData,
                processing: false,
                errors: errors
            });
            return false;
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        let isFormValid = true;
        const tagNames = ['select', 'input', 'textarea'];
        console.log(formData);

        for (let tagName of tagNames) {
            //validate full form
            for (let i = 0; i < event.target.getElementsByTagName(tagName).length; i++) {
                let fieldName = event.target.getElementsByTagName(tagName)[i].name;
                let fieldValue = event.target.getElementsByTagName(tagName)[i].value;
                let { hasError, error } = validateInput(fieldName, fieldValue);
                setFormValidityData({
                    ...formValidityData,
                    [fieldName + 'Error']: hasError,
                    [fieldName + 'ErrMsg']: error
                })
                if (hasError) {
                    isFormValid = false;
                    alert("Form has validation error")
                    return false;
                }
            }
        }

        if (!isFormValid) {
            alert("The form still has validation errors!");
            return false;
        }
        setFormData({ ...formData, readOnly: true, processing: true });
        if (_.isEmpty(formData.paymentCardId)) {
            if (paymentGateway === 'ELAVON') {
                //if every thing works open light box to collect card data
                openLightbox({
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    mobilePhoneNumber: formData.mobilePhoneNumber,
                    address: formData.address,
                    city: formData.city,
                    state: formData.state,
                    zip: formData.zip
                }, handlePaymentResult);
            } else {
                const status = await saveCardFunction.current();
            }
        } else {
            handlePaymentResult({ paymentStatus: 'SUCCEEDED' });
        }

    }

    const fillAmount = (event, donationAmount, causeAttrDescription) => {
        causeAmountFieldRef.current.focus();
        setFormData({
            ...formData,
            currentDonationCauseValue: donationAmount,
            causeAttrDescription: causeAttrDescription
        });
    }

    return (
        <>
            {formData.processing && <AppSpinner style={{ marginBottom: 27 }} animation="border" variant="success" />}
            <FormContainer title="One Click Payments" submitButtonFunction={handleSubmit}
                errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
                <Row><Col>Please verify that the information given in the section labeled "Payment Card address verrification" corresponds to your payment card billing address. It is used for card verification.
                    It will be used to verify the payment card. When you click "Add Card Information and Save One Click Payment", a popup will request card information.
                    Please enter card infomration that will be used to make the One Click payments and press submit.
                    A payment will <b>not </b>be made at this time. This will create a tile on the Home page which can be used to make a payment by clicking on it.
                </Col></Row>
                <Row>
                    {mediaType && <Col className="d-flex justify-content-start" md={4} lg={4} sm={12}>
                        <Image src={process.env.REACT_APP_BASE_API_URL + BUSINESS_DONATION_CAUSES_URL + '/' + formData.currentDonationCause + '/img'} fluid />
                    </Col>}
                    <Col sm={12} md={4} lg={4}>
                        <Row>
                            <Col>
                                <FormField name="currentDonationCause" label="Select Cause" type="select" readOnly={formData.readOnly}
                                    onChange={handleDonationCauseChange} onBlur={handleValidation} value={formData.currentDonationCause}
                                    valstate={!formValidityData.currentDonationCauseError} valMsg={formValidityData.currentDonationCauseErrMsg}>
                                    <option value="" key="zeroval"></option>
                                    {formData.donationLineItems.map((donationLineItem, idx) => (
                                        <option value={donationLineItem.causeId} key={idx}>{donationLineItem.lineItemDescription}</option>
                                    ))}
                                </FormField>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormField name="currentDonationCauseValue" type="text" label="Donation Amount" readOnly={formData.readOnly}
                                    onChange={handleFormDataChange} onBlur={handleValidation} value={formData.currentDonationCauseValue}
                                    valstate={!formValidityData.currentDonationCauseValueError} valMsg={formValidityData.currentDonationCauseValueErrMsg}
                                    rref={causeAmountFieldRef} />
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                {selectedCauseAttributes && !hasDescription && <>
                                    {selectedCauseAttributes.map((causeAttr, idx) => {
                                        let donAmount = parseFloat(causeAttr.suggestedAmount) / 100;
                                        return (<React.Fragment key={idx}>
                                            <Button variant='secondary' className='mt-1 p-2 btn-fill' onClick={event => fillAmount(event, donAmount)}>
                                                {formatCurrency(donAmount, businessConfig.locale, businessConfig.currency)}
                                            </Button>
                                            &nbsp;</React.Fragment>);
                                    })}

                                    {(selectedCauseAttributes && selectedCauseAttributes.length > 1)
                                        && <Button variant='secondary' className='mt-1 p-2 btn-fill' onClick={event => fillAmount(event, "0.00")} key="custamount">Custom Amount</Button>}
                                </>}
                                {selectedCauseAttributes && hasDescription &&
                                    <Row>
                                        {selectedCauseAttributes.map((causeAttr, idx) => {
                                            let donAmount = parseFloat(causeAttr.suggestedAmount) / 100;
                                            return (<React.Fragment key={idx}>
                                                <Col sm={12} md={12} lg={12}>
                                                    <Button variant='secondary' className='mt-2 p-2 btn-fill flex-fill w-100' onClick={event => fillAmount(event, donAmount, causeAttr.description)}>
                                                        {formatCurrency(donAmount, businessConfig.locale, businessConfig.currency)} - {causeAttr.description.toUpperCase()}
                                                    </Button>
                                                </Col>

                                            </React.Fragment>);
                                        })}
                                        {(selectedCauseAttributes && selectedCauseAttributes.length > 1)
                                            && <Col sm={12} md={12} lg={12}>
                                                <Button variant='secondary' className='mt-2 p-2 btn-fill flex-fill w-100' onClick={event => fillAmount(event, "0.00")} key="custamount">Custom Amount</Button>
                                            </Col>}
                                    </Row>}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="description" label="Description for tile on home page" type="text" value={formData.description}
                            placeholder="Description" onChange={handleFormDataChange} onBlur={handleValidation}
                            valstate={!formValidityData.descriptionError} valMsg={formValidityData.descriptionErrMsg}
                            readOnly={formData.readOnly} />
                    </Col>

                </Row>

                <Row><Col>&nbsp;</Col></Row>
                <Row>
                    <Col>
                        <Table><tbody>
                            <tr><td className="mt-4 p-0" style={{ borderStyle: 'none' }} colSpan="2">
                                If you would like to have the receipt for the recurring payments in the name of your organization,
                                update the "Company Name" field in the User Profile and select this checkbox.
                            </td></tr>
                            <tr>
                                <td className="m-0 p-0" style={{ borderStyle: 'none' }} width="35px">
                                    <br /><FormField
                                        name="receiptInCompanyName"
                                        type="checkbox"
                                        checktype="checkbox"
                                        disabled={formData.readOnly || _.isEmpty(formData.companyName)}
                                        value={formData.receiptInCompanyName}
                                        checked={formData.receiptInCompanyName}
                                        onChange={handleFormDataChange}
                                        onBlur={handleValidation}
                                        valstate={!formValidityData.receiptInCompanyNameError}
                                        valMsg={formValidityData.receiptInCompanyNameErrMsg} />
                                </td>
                                <td className="m-0 p-0" style={{ borderStyle: 'none' }}>
                                    <br /><label><nobr>Receipt In Company Name <FontAwesomeIcon icon={faInfoCircle} title="may be disabled due to absence of Company Name in user profile" /></nobr></label>
                                </td>
                            </tr>
                        </tbody></Table>
                    </Col>
                </Row>

                <Row>
                    <Col><br /><h6>User Profile Summary</h6>
                        These fields can be modified in the user profile screen.
                    </Col>
                </Row>

                <Row>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="email" label="Email" type="text" value={formData.email}
                            placeholder="Email" onChange={handleFormDataChange} onBlur={handleValidation}
                            valstate={!formValidityData.emailError} valMsg={formValidityData.emailErrMsg}
                            readOnly={true} />
                    </Col>

                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="mobilePhoneNumber" label="Mobile Phone Number" type="text" value={formData.mobilePhoneNumber}
                            placeholder="Mobile Phone Number" onChange={handleFormDataChange} onBlur={handleValidation}
                            valstate={!formValidityData.mobilePhoneNumberError} valMsg={formValidityData.mobilePhoneNumberErrMsg}
                            readOnly={true} />
                    </Col>
                </Row>

                <Row>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="companyName" label="Company Name" type="text" value={formData.companyName}
                            placeholder="Company Name" onChange={handleFormDataChange} onBlur={handleValidation}
                            valstate={!formValidityData.companyNameError} valMsg={formValidityData.companyNameErrMsg}
                            readOnly={true} />
                    </Col>
                </Row>

                {!_.isEmpty(formData.paymentCards) && (formData.paymentCards.length > 0) &&
                    <><Row>
                        <Col><br /><h6>Payment Cards</h6><br /></Col>
                    </Row>
                        <Row>
                            <Col mb={6} lg={6} sm={12}>
                                <FormField name="paymentCardId" label="Payment Cards" type="select"
                                    placeholder="Payment Cards" onChange={handleFormDataChange} onBlur={handleValidation}
                                    valstate={!formValidityData.paymentCardIdError} valMsg={formValidityData.paymentCardIdErrMsg}
                                    readOnly={formData.readOnly} value={formData.paymentCardId}>
                                    <option value="" key="noval">Select Payment Card</option>
                                    {formData.paymentCards.map((paymentCard, idx) => (
                                        <option value={paymentCard.paymentCardId} key={idx}>{paymentCard.maskedAccountNumber}</option>

                                    ))}
                                </FormField>
                                <small><strong>if not selected, you will be able to enter payment card details manually when you click the "Update Card and Save One Click Payment" button</strong></small>

                            </Col>

                        </Row></>}

                {_.isEmpty(formData.paymentCardId) && <>
                    <Row>
                        <Col>
                            <br /><h6>Payment Card Address Verification</h6><br />
                        </Col>
                    </Row>

                    <Row>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="firstName" label="First Name" type="text" value={formData.firstName}
                                placeholder="First Name" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.firstNameError} valMsg={formValidityData.firstNameErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="lastName" label="Last Name" type="text" value={formData.lastName}
                                placeholder="Last Name" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.lastNameError} valMsg={formValidityData.lastNameErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={12} lg={12} sm={12}>
                            <FormField name="address" label="Address" type="text" value={formData.address}
                                placeholder="Address" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.addressError} valMsg={formValidityData.addressErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={2} lg={2} sm={6}>
                            <CountrySelect name="country" onChange={handleCountryChange} onBlur={handleValidation}
                                valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
                                readOnly={formData.readOnly} value={formData.country} />
                        </Col>
                        <Col mb={4} lg={4} sm={12}>
                            <FormField name="city" label="City" type="text" value={formData.city}
                                placeholder="City" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.cityError} valMsg={formValidityData.cityErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={3} lg={3} sm={6}>
                            <ProvinceSelect name="state" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.stateError} valMsg={formValidityData.stateErrMsg}
                                readOnly={formData.readOnly} value={formData.state} country={formData.country} />
                        </Col>
                        <Col mb={4} lg={4} sm={6}>
                            <PostalCode name="zip" label="Postal Code" type="text" value={formData.zip}
                                placeholder="Postal Code" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.zipError} valMsg={formValidityData.zipErrMsg}
                                readOnly={formData.readOnly} country={formData.country} />
                        </Col>
                    </Row>
                </>}

                <Row><Col>
                    <Table>
                        <tbody>
                            <tr>
                                {businessConfig.businessFee.feePayer === 'CUSTOMER_OPTIONAL' && <td style={{ paddingLeft: 0 }}>
                                    <FormField
                                        type="checkbox"
                                        name="customerConsentsToPayPfFees"
                                        value={formData.customerConsentsToPayPfFees || false}
                                        checked={formData.customerConsentsToPayPfFees || false}
                                        onChange={handleFormDataChange}
                                    />
                                </td>}
                                <td>
                                    {
                                        businessConfig.businessFee.feePayer === 'CUSTOMER_OPTIONAL' &&
                                        <>Payer agrees to pay for the transaction cost of:
                                            <b>{businessConfig.businessFee.feeType === 'FIXED'
                                                ? formatCurrency(parseFloat(businessConfig.businessFee.fee / 100), businessConfig.locale, businessConfig.currency)
                                                : businessConfig.businessFee.fee + "%"}</b></>
                                    }
                                    {
                                        businessConfig.businessFee.feePayer === 'CUSTOMER_MANDATORY' &&
                                        <>Payer is required to cover the transaction cost of:
                                            <b>{businessConfig.businessFee.feeType === 'FIXED'
                                                ? formatCurrency(parseFloat(businessConfig.businessFee.fee / 100), businessConfig.locale, businessConfig.currency)
                                                : businessConfig.businessFee.fee + "%"}</b></>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col></Row>

                {!formData.pmtResult && _.isEmpty(formData.paymentCardId) && formData?.zip && paymentGateway && paymentGateway === 'STRIPE' && <>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            <StripeElements formData={formData} saveCardFunction={saveCardFunction} handlePaymentResult={handlePaymentResult} />
                        </Col>
                    </Row>
                </>}

                {!formData.pmtResult &&
                    <Row><Col>
                        <div>This will save the card information and create a widget on home page for conviniently making payments from home page.
                            When you click the button below, it only saves the payment information but <b>does NOT make any payment</b> at this time.</div>
                        <br />
                        <SubmitButton label={(formData.editMode ? 'Update' : 'Add') + ' Card Information and Save One Click Payment'} disabled={formData.readOnly} className="me-4" />
                        <CancelButton label='Return to List Page' onClick={handleCancel} />
                    </Col>
                    </Row>}
            </FormContainer>
        </>
    )
}

export default OneClickPaymentPage